import React, { useState, useEffect } from 'react';
import { Card, Grid, makeStyles, Typography, useTheme } from '@material-ui/core';
import StatusData from './StatusLabel';
import { PieChart, Pie, Sector, ResponsiveContainer, Cell } from 'recharts';
import { blueGrey } from '@material-ui/core/colors';
import { useMediaQuery } from '@material-ui/core';

const chart_size_lg = 200
const chart_size_md = 120


const ActivationsCard = ({approved, rejected, total, catalogs}) => {

    const classes = useStyles()
    const theme = useTheme()
    const [active_index, setActiveIndex] = useState(0)
    const is_medium = useMediaQuery(theme.breakpoints.only('md'))

    const mock_data = [
        { id:1, label: 'Approved', value: 400, color: catalogs.activations[0].color },
        { id:2, label: 'Rejected', value: 300, color: catalogs.activations[1].color },
    ];

    
    const onMouserEnter = (_, index) => {
        setActiveIndex(index)
    }

    const chart_size = is_medium ? chart_size_md : chart_size_lg

    let chart_data = JSON.parse(JSON.stringify(mock_data))
    chart_data[0].value = approved
    chart_data[1].value = rejected

    

    //const total = 93

    return ( 
        <Card className={classes.card}>
            <div className={classes.container}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <div className={classes.graph_content}>
                            <PieChart width={chart_size} height={chart_size} >
                                <Pie
                                    data={mock_data}
                                    cx='50%'
                                    cy='50%'
                                    innerRadius={ !is_medium ? 60 : 35}
                                    outerRadius={ !is_medium ? 80 : 50}
                                    fill="#8884d8"
                                    paddingAngle={5}
                                    dataKey="value"
                                    >
                                    {mock_data.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={mock_data[index].color} />
                                    ))}
                                </Pie>
                            </PieChart>
                            <div className={classes.quantity}>
                                <Typography className={classes.number}>{total}</Typography>
                            </div>
                            
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div style={{paddingTop:16, paddingBottom:16}}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Typography variant='subtitle1' color='primary' style={{fontWeight:600}}>Activations</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={1}>
                                        {chart_data.map(item => {

                                            const value = item.id === 1 ? approved : rejected

                                            return(
                                                <Grid item xs={12} key={item.id.toString()}>
                                                    <Grid container>
                                                        <Grid item xs={12}>
                                                            <StatusData data={item.label} color={item.color} variant='subtitle2'/>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography variant='body2' color='textSecondary' style={{marginLeft:22}} >{`${value} items`}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            )
                                        })}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                        
                    </Grid>
                </Grid>
            </div>
        </Card>

     );
}

const useStyles = makeStyles(theme => ({
    card:{
        boxShadow:'rgba(149, 157, 165, 0.2) 0px 8px 24px',
        borderRadius:8,
        
    },
    container:{
        padding:'12px 20px',
        paddingBottom:0,
        height:'100%'
    },
    graph_content:{
        width:chart_size_lg,
        height:chart_size_lg,
        position:'relative',
        margin:'auto',
        [theme.breakpoints.only('md')]:{
            width:chart_size_md,
            height:chart_size_md,
        }
    },
    graph:{
        position:'absolute',
        width:'100%',
        height:'100%',
        top:0, left:0,
    },
    number:{
        color:blueGrey[900],
        fontSize:'2.5rem',
        lineHeight:1,
        fontWeight:600
    },
    quantity:{
        position:'absolute',
        top:'50%', left:'50%',
        transform:'translate(-50%, -50%)'
    }
}))
 
export default ActivationsCard;


